package com.karyadina.cloudsync.service

/**
 * Google Drive Service interface
 * Handles file upload/download operations on Google Drive
 * Files are encrypted before upload
 */
interface GoogleDriveService {
    /**
     * Upload encrypted file to Google Drive
     * @param fileName File name with .dina extension
     * @param encryptedData Encrypted file content
     * @return File ID on Google Drive
     */
    suspend fun uploadFile(fileName: String, encryptedData: ByteArray): Result<String>
    
    /**
     * Download encrypted file from Google Drive
     * @param fileId File ID on Google Drive
     * @return Encrypted file content
     */
    suspend fun downloadFile(fileId: String): Result<ByteArray>
    
    /**
     * List all .dina files on Google Drive
     */
    suspend fun listFiles(): Result<List<DriveFileInfo>>
    
    /**
     * Delete file from Google Drive
     */
    suspend fun deleteFile(fileId: String): Result<Unit>
    
    /**
     * Get file size on Google Drive
     */
    suspend fun getFileSize(fileId: String): Result<Long>
    
    /**
     * Check if authenticated with Google Drive
     */
    suspend fun isAuthenticated(): Result<Boolean>
    
    /**
     * Get total storage used
     */
    suspend fun getTotalStorageUsed(): Result<Long>
}

data class DriveFileInfo(
    val fileName: String,
    val fileId: String,
    val size: Long, // in bytes
    val modifiedTime: Long // milliseconds
)
